import { usePrefs } from "@/context/PrefsContext";

const dict = {
  "pt-BR": {
    "nav.dashboard": "Início", "nav.markets": "Mercados", "nav.portfolio": "Carteira", "nav.wallet": "Depósitos e saques",
    "nav.notifications": "Notificações", "nav.profile": "Perfil e documentos", "nav.security": "Segurança",
    "nav.admin.overview": "Visão geral", "nav.admin.clients": "Clientes", "nav.admin.finance": "Financeiro",
    "nav.admin.trading": "Operações", "nav.admin.documents": "Documentos", "nav.admin.notifications": "Comunicados",
    "nav.admin.assets": "Ativos", "nav.admin.reports": "Relatórios", "nav.admin.admins": "Administradores",
    "demo.badge": "MODO DEMONSTRAÇÃO", "demo.note": "Saldo virtual. Nenhuma ordem é enviada a uma corretora real.",
  },
  en: {
    "nav.dashboard": "Home", "nav.markets": "Markets", "nav.portfolio": "Portfolio", "nav.wallet": "Deposits & withdrawals",
    "nav.notifications": "Notifications", "nav.profile": "Profile & documents", "nav.security": "Security",
    "nav.admin.overview": "Overview", "nav.admin.clients": "Clients", "nav.admin.finance": "Finance",
    "nav.admin.trading": "Trading", "nav.admin.documents": "Documents", "nav.admin.notifications": "Announcements",
    "nav.admin.assets": "Assets", "nav.admin.reports": "Reports", "nav.admin.admins": "Administrators",
    "demo.badge": "DEMO MODE", "demo.note": "Virtual balance. No order is sent to a real broker.",
  },
};

export const LANGS = [{ code: "pt-BR", label: "Português (BR)" }, { code: "en", label: "English (beta)" }];

export function useT() {
  const { lang } = usePrefs();
  return (key) => dict[lang]?.[key] ?? dict["pt-BR"][key] ?? key;
}
